<template>
  <div>
    <Slider
      class="mb-6"
      v-if="slides.length"
      :class="$style.slider"
      :slides="slides"
      :options="{ ...opt, autoplay: slider_autoplay }"
      name="BannerSlider"
      default_pagination
      default_navigation
      @slideClick="handle_click"
    >
      <template #slide="{ slide }">
        <div :class="$style.slide">
          <img
            :class="$style.slideImg"
            :src="slide"
            loading="lazy"
            alt=""
          >
        </div>
      </template>
    </Slider>
  </div>
</template>

<script lang="ts">
import {
  Vue, Prop, Component,
} from 'vue-property-decorator';
import { Banner, SwiperOption } from '@/types';
import { GlobalService } from '@/shared/services';
import { Slider } from '../slider';

const globalsService = new GlobalService();

@Component({
  components: {
    Slider,
  },
})
export default class InfoBanner extends Vue {
  @Prop({ type: String, default: '', required: true })
  module_name!: '';

  slides: Banner[] = []

  async mounted() {
    const response = await globalsService.get_banners({
      filters: {
        page: this.module_name,
      },
    });

    this.slides = response.data.items;
  }

  opt: SwiperOption = {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 7000,
    },
  };

  get slider_autoplay() {
    const { slides } = this;

    return slides.length <= 1 ? false : { delay: 7000 };
  }

  async handle_click(slide: Record<string, string | number>) {
    if (
      typeof slide.id === 'number'
    && typeof slide.url === 'string'
    && slide.url.includes('https')
    ) {
      await globalsService.send_banner_id(slide.id);
      window.open(slide.url, '_blank');
    }
  }
}
</script>

<style module lang="scss">
.slider {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 16px !important;
  .sliderContainer {
    padding: 0;
  }
}

.slide {
  width: 100%;
  min-height: 60px;
  aspect-ratio: 15 / 1;
  overflow: hidden;
  cursor: pointer;
}

.slideImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
</style>
